<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e1498">
<p class="txc">To Peter Ady</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?ebcddc78